import cx from "classnames";
import styles from "../NotificationSection.module.css";
import { TradingDocument } from "api/trading-documents/models";
import { useSendEmailNotification } from "../hooks/useSendEmailNotification";
import { Button } from "components/miloDesignSystem/atoms/button";
import { MdiSend } from "components/miloDesignSystem/atoms/icons/MdiSend";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { MdiFolderOpen } from "components/miloDesignSystem/atoms/icons/MdiFolderOpen";

interface Props {
  tradingDocument: TradingDocument;
  open: () => void;
}

export const EmptyNotificationSection = ({ tradingDocument, open }: Props) => {
  const sendEmailNotificationMutation = useSendEmailNotification();

  return (
    <div className="pb-3">
      <div className={styles.sectionEmpty}>
        <MdiFolderOpen color="neutralBlack48" />
        <Typography className={cx(styles.sectionEmptyTitle, "pt-2")} fontSize="12" fontWeight="700">
          Jeszcze nie wysłano żadnej faktury
        </Typography>
        <div className="py-2 d-flex align-items-center gap-2">
          <Button
            className="text-uppercase"
            isLoading={sendEmailNotificationMutation.isLoading}
            onClick={() =>
              sendEmailNotificationMutation.mutate({
                tradingDocumentId: tradingDocument.id,
              })
            }
            size="small"
            startIcon={MdiSend}
            variant="gray"
          >
            Wyślij teraz
          </Button>
          <Button
            className="text-uppercase"
            onClick={open}
            size="small"
            startIcon={MdiSend}
            variant="gray"
          >
            Wskaż adres i wyślij
          </Button>
        </div>
      </div>
    </div>
  );
};
